<div class="activity-select-dialog">
  <!-- Search bar -->
  <div class="search-bar">
    <div class="search-input-wrapper">
      <input class="search-input"
             type="text"
             [formControl]="searchControl"
             placeholder="Search activities"
             autocomplete="off"
             cdkFocusInitial>
      <div class="search-underline"></div>
    </div>
    <div class="filter-stack">
      <button class="filter-btn" [class.active]="viewMode === 'sah'" (click)="setViewMode('sah')">S@H</button>
      <button class="filter-btn" [class.active]="viewMode === 'all'" (click)="setViewMode('all')">ALL</button>
    </div>
    <button mat-flat-button
            color="primary"
            class="select-btn"
            [disabled]="!selectedActivity"
            (click)="onSelect()">
      Select
    </button>
    <button mat-icon-button
            class="close-btn"
            (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="activity-content">
    <!-- Client history section -->
    <div class="activity-section" *ngIf="getFilteredClientTopActivities().length > 0">
      <p class="section-label">Based on this client's history</p>
      <div class="activity-grid">
        <button *ngFor="let activity of getFilteredClientTopActivities()"
                class="activity-tile"
                [class.selected]="isSelected(activity.activity_id)"
                (click)="onAdhocActivityClick(activity)">
          <span class="activity-tile-name">{{ activity.activity_name }}</span>
          <span class="activity-tile-meta">{{ activity.count }} uses</span>
        </button>
      </div>
    </div>

    <!-- Most common section -->
    <div class="activity-section" *ngIf="getFilteredTopAdhocActivities().length > 0">
      <p class="section-label">Most common</p>
      <div class="activity-grid">
        <button *ngFor="let activity of getFilteredTopAdhocActivities()"
                class="activity-tile"
                [class.selected]="isSelected(activity.activity_id)"
                (click)="onAdhocActivityClick(activity)">
          <span class="activity-tile-name">{{ activity.activity_name }}</span>
          <span class="activity-tile-meta">{{ activity.count }} uses</span>
        </button>
      </div>
    </div>

    <!-- S@H view (when not searching) -->
    <div class="activity-section" *ngIf="viewMode === 'sah' && !searchControl.value">
      <p class="section-label">S@H Activities</p>
      <div class="activity-grid">
        <button *ngFor="let activity of getSahActivities()"
                class="activity-tile"
                [class.selected]="isSelected(activity.activity_detail_id)"
                (click)="onCommonActivityClick(activity)">
          <span class="activity-tile-name">{{ activity.description }}</span>
          <span class="activity-tile-parent">{{ activity.parent_description }}</span>
        </button>
      </div>
    </div>

    <!-- S@H / ALL search results -->
    <div class="activity-section" *ngIf="searchControl.value && filteredActivities.length > 0">
      <p class="section-label">{{ viewMode === 'sah' ? 'S@H' : 'All' }} Activities</p>
      <div class="activity-grid">
        <button *ngFor="let activity of filteredActivities"
                class="activity-tile"
                [class.selected]="isSelected(activity.id)"
                (click)="onSearchResultClick(activity)">
          <span class="activity-tile-name">{{ activity.description }}</span>
          <span class="activity-tile-parent">{{ activity.parentDescription }}</span>
        </button>
      </div>
    </div>

    <!-- ALL view — group grid (when not searching) -->
    <div class="activity-section" *ngIf="viewMode === 'all' && !selectedActivityGroup && !searchControl.value">
      <p class="section-label">All Activities</p>
      <p class="section-hint">Pick a category first, then choose the exact activity.</p>
      <div class="activity-group-grid">
        <button *ngFor="let group of sortedActivityGroups"
                class="activity-group-btn"
                (click)="selectActivityGroup(group)">
          <span class="activity-group-label">{{ group.description }}</span>
          <span class="activity-group-count">{{ group.activities.length }}</span>
        </button>
      </div>
    </div>

    <!-- ALL view — child list (drilled in, when not searching) -->
    <div class="activity-section" *ngIf="viewMode === 'all' && selectedActivityGroup && !searchControl.value">
      <div class="activity-breadcrumb">
        <button mat-icon-button (click)="clearActivityGroup()" class="breadcrumb-back">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="breadcrumb-label">{{ selectedActivityGroup.description }}</span>
      </div>
      <div class="activity-grid">
        <button *ngFor="let activity of selectedActivityGroup.activities"
                class="activity-tile"
                [class.selected]="isSelected(activity.id)"
                (click)="onChildActivityClick(activity)">
          <span class="activity-tile-name">{{ activity.description }}</span>
        </button>
      </div>
    </div>

    <!-- No results -->
    <p class="no-results" *ngIf="searchControl.value && filteredActivities.length === 0 && getFilteredClientTopActivities().length === 0 && getFilteredTopAdhocActivities().length === 0">
      No activities match "{{ searchControl.value }}"
    </p>
  </mat-dialog-content>
</div>
